module.exports = __webpack_public_path__ + "media/components/country-flag/static/sz-1f262711846895ebdd42162f1ff5f921.svg";